import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function PiggyBank({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M13.9702 4.01999C15.3302 5.37999 15.3302 7.59999 13.9702 8.95999C12.6002 10.32 10.3802 10.32 9.02019 8.95999C7.65019 7.58999 7.65019 5.36999 9.01919 4.00999C10.3792 2.63999 12.5992 2.63999 13.9592 4.00899M17.0302 11.96C17.0402 11.97 17.0402 12 17.0302 12.02C17.0102 12.03 16.9802 12.03 16.9602 12.02C16.9402 12 16.9402 11.97 16.9602 11.95C16.9702 11.93 17.0002 11.93 17.0202 11.95M14.9802 6.85899C15.3002 6.76899 15.6102 6.64899 15.9002 6.46899C16.3602 6.16899 16.9002 5.99899 17.4902 5.99899H18.4902V8.54899C19.2082 9.18899 19.7702 9.99899 20.1102 10.929H20.9802C21.5302 10.929 21.9802 11.369 21.9802 11.929V14.989C21.9802 15.539 21.5302 15.989 20.9802 15.989H19.6602C19.1302 16.889 18.3702 17.649 17.4712 18.179V19.979C17.4712 20.529 17.0212 20.979 16.4712 20.979H14.4712C13.9112 20.979 13.4712 20.529 13.4712 19.979V18.979H9.97119V19.839C9.97119 20.389 9.52119 20.839 8.97119 20.839H6.97119C6.41119 20.839 5.97119 20.389 5.97119 19.839V17.429C4.74119 16.329 3.97119 14.739 3.97119 12.959C3.97119 10.309 5.68919 8.06799 8.06119 7.26899M2.28019 9.99999C1.81019 10.27 1.49219 10.77 1.49219 11.35C1.49219 12.22 2.19219 12.927 3.06219 12.927H3.98519M8.50019 9.99999H14.5002" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default PiggyBank;